export const getWeekName = (EpochDateTime: number) => {
  const { dayjs, userTimeZone } = useDayjs();
  const dayOfWeek = dayjs.unix(EpochDateTime).tz(userTimeZone).day();
  const { $t } = useTranslate();
  return [$t("title25"), $t("title26"), $t("title27"), $t("title28"), $t("title29"), $t("title30"), $t("title31")][
    dayOfWeek
  ];
};
